"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const IconButton_1 = tslib_1.__importDefault(require("@mui/material/IconButton"));
const styles_1 = require("@mui/material/styles");
/**
 *
 * This component is only intended to be used internally in mui5
 *
 * @internal
 */
const RailIconButton = react_1.default.forwardRef((props, ref) => {
    const { isSelected, variant = "icon", sx, ...restProps } = props;
    return (react_1.default.createElement(IconButton_1.default, { component: "a", "aria-current": isSelected, ref: ref, sx: [
            (theme) => ({
                borderRadius: 0,
                p: variant === "icon" ? 2.5 : 2,
                backgroundColor: isSelected && (0, styles_1.alpha)((0, styles_1.hexToRgb)(theme.palette.primary.main), 0.08),
            }),
            ...(Array.isArray(sx) ? sx : [sx]),
        ], ...restProps }));
});
exports.default = RailIconButton;
